import { useState } from 'react';
import VideoCard from '../VideoCard';
import './Members.css';
import videos from '../videoData';
import VideoDetails from '../VideoDetails';

function Members() {
    // controls which grade's videos to show
    const [showVideos, setShowVideos] = useState(videos[0]);

    // controls heading to display depending on selected grade
    const [videosHeading, setVideosHeading] = useState('Kindergarten');

    // controls which video to display details page from user click
    const [showVideoDetails, setShowVideoDetails] = useState(null);

    // updates state of shown videos & page heading
    const handleGradeButtonClick = (videoList, heading) => {
        setShowVideos(videoList);
        setVideosHeading(heading);
        setShowVideoDetails(null);
    };

    const backButtonClicked = () => {
        setShowVideoDetails(null);
        window.scrollTo(0, 0);
    };

    const handleVideoClick = (e) => {
        const dataAttr = e.currentTarget.getAttribute('data-video-index');
        const videoIndex = Number(dataAttr);
        const selectedVideo = Number.isFinite(videoIndex) ? showVideos[videoIndex] : undefined;

        if (!selectedVideo) return;

        setShowVideoDetails(
            <>
                <VideoDetails
                    videoTitle={selectedVideo.title}
                    videoUrl={selectedVideo.url}
                    videoResourceUrl={selectedVideo.resource} />
                <button
                    type="button"
                    className="members__back-button"
                    onClick={() => backButtonClicked()}>
                    Back to Videos
                </button>
            </>,
        );
    };

    const gradeNames = [
        'Kindergarten',
        'Grade 1',
        'Grade 2',
        'Grade 3',
        'Grade 4',
        'Grade 5',
        'Grade 6',
        'Technology',
    ];

    return (
        <div className="members__container">
            <div className="members__button-container">
                {/* grades nav menu */}
                <ul className="members__grade-buttons">
                    {gradeNames.map((gradeName, index) => (
                        <li key={gradeName}>
                            <button
                                type="button"
                                className="members__button"
                                onClick={() => {
                                    handleGradeButtonClick(
                                        videos[index],
                                        gradeName,
                                    );
                                }}>
                                {gradeName}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            {showVideoDetails || (
                <div className="members__videos-container">
                    <div className="members__videos-content-container">
                        <div className="members__heading">{videosHeading}</div>
                        <div className="members__videos">
                            {showVideos.map((video, index) => (
                                <VideoCard
                                    key={video.id}
                                    videoIndex={index}
                                    thumbnail={video.thumbnail}
                                    title={video.title}
                                    description={video.description}
                                    handleVideoClick={(event) => handleVideoClick(event)} />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Members;
